import type { AppRouteRecordRaw } from '@/router/types'
import { useI18n } from '@/hooks/web/useI18n'
import { LAYOUT, BLANK } from '@/router/constant'

const { t } = useI18n()
const dataSynchronous_routes: AppRouteRecordRaw[] = [
  // 数据同步
  {
    path: '/dataSynchronous',
    name: 'dataSynchronous',
    component: LAYOUT,
    meta: {
      title: t('router.dataSynchronous'),
      hideBreadcrumb: true,
      hideMenu: false,
      icon: 'city-10'
    },
    children: [
      // 数据备份
      {
        path: 'data-backup',
        name: 'data-backup',
        component: BLANK,
        redirect: '/dataSynchronous/data-backup/index',
        meta: {
          title: t('router.dataBackup'),
          hideBreadcrumb: true,
          master: true,
          hideMenu: false
        },
        children: [
          {
            path: 'index',
            name: 'data-backup-list',
            component: () => import('@/views/dataSynchronous/data-backup/index.vue'),
            meta: {
              title: t('router.dataBackup'),
              hideBreadcrumb: true,
              master: true,
              hideMenu: false
            }
          }
        ]
      },
      // 数据恢复
      {
        path: 'data-upload',
        name: 'data-upload',
        component: BLANK,
        redirect: '/dataSynchronous/data-upload/index',
        meta: {
          title: t('router.dataUpload'),
          hideBreadcrumb: true,
          master: true,
          hideMenu: false
        },
        children: [
          {
            path: 'index',
            name: 'data-upload-list',
            component: () => import('@/views/dataSynchronous/data-upload/index.vue'),
            meta: {
              title: t('router.dataUpload'),
              hideBreadcrumb: true,
              master: true,
              hideMenu: false
            }
          }
        ]
      }
    ]
  }
]

export default dataSynchronous_routes
